/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

export type DashboardCreateUserAdditionalRolesItem =
  (typeof DashboardCreateUserAdditionalRolesItem)[keyof typeof DashboardCreateUserAdditionalRolesItem];

export const DashboardCreateUserAdditionalRolesItem = {
  ATHLETE: "ATHLETE",
  CLUB_MANAGER: "CLUB_MANAGER",
  CLUB_OWNER: "CLUB_OWNER",
  FEDERATION_MEMBER: "FEDERATION_MEMBER",
  TOURNAMENT_ORGANIZER: "TOURNAMENT_ORGANIZER",
  REFEREE: "REFEREE",
  FAN: "FAN",
  OTHER: "OTHER",
} as const;
